// extracted by mini-css-extract-plugin
module.exports = {"price":"product-banner_price_2veQN"};